import { SIDENAV_ACTION_TYPES } from '@constants/actionTypes/sideNavActionTypes';

export const INITIAL_STATE = {
    idmUserStatus: '',
    userStatus: '',
    hhUserId: '',
    hhFirstName: '',
    hhLastName: '',
    encHHId: '',
    hhId: '',
    hhUser: '',
    calheersEnv: '',
    addNewViewCaseUrl: '',
    checkDilog: '',
    permissionMap: {},
    switchToModuleName: '',
    hhEmail: '',
    hhPhone: '',
    hhUserStatus: '',
    activeModuleName: '',
    unreadMessageCount: 0,
};
interface ISideNavAction {
    type: string;
    payload?: any;
}

// Reducer function with typed state and action
export default (state = INITIAL_STATE, action: ISideNavAction) => {
    switch (action?.type) {
        case SIDENAV_ACTION_TYPES.SET_SIDE_NAV_DETAILS:
            return {
                ...state,
                ...action.payload,
            };
        case SIDENAV_ACTION_TYPES.SET_SIDE_NAV_UNREAD_MESSAGE_COUNT:
            return {
                ...state,
                unreadMessageCount: action.payload,
            };
        default:
            return state;
    }
};

